var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{staticClass:"editor",attrs:{"value":_vm.value,"options":_vm.editorOption},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }